export default "__VITE_ASSET__f3146836__"